import { Component, OnInit } from "@angular/core";

@Component({
  selector: "error",
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})

export class ErrorComponent implements OnInit {

  errorMsg: string = '';

  constructor() {

  }

  ngOnInit() {
    this.errorMsg = localStorage.getItem("error-message");
    localStorage.clear();
  }


}
